import React from 'react';
import Tooltip from '@mui/material/Tooltip';

class HotelAutocompleteLabel extends React.Component {
  render() {
    const text = this.props.label == null ? '' : String(this.props.label);
    if (!text) return null;

    return (
      <Tooltip title={text} placement="top" enterDelay={300}>
        <span className="hotel-autocomplete-label">{text}</span>
      </Tooltip>
    );
  }
}

export default HotelAutocompleteLabel;
